






















import { Component, Prop, Vue } from 'vue-property-decorator';
import VuePerfectScrollbar from 'vue-perfect-scrollbar';
import { Common } from '@/core/Common';

enum SelectionState {
    ALL = "все",
    SOME = "несколько",
}

@Component ({
  components: { VuePerfectScrollbar },
})
export default class extends Vue {
    @Prop({default: "Значения"}) name!: string;
    @Prop({default: []}) options!: any[];
    @Prop({default: null}) optionKey!: string;
    @Prop({default: 300}) listHeight!: number;
    @Prop({default: false}) single!: boolean;
    @Prop() defaultSelected: any;

    isOpened: boolean = false;
    selectedElement: any = this.defaultSelected == null ? this.options[0] : this.defaultSelected;
    selectionState: SelectionState = SelectionState.ALL;
    selectedOptions: boolean[] = new Array<boolean>(this.options.length).fill(true);

    getScrollSettings() {
        return Common.GetScrollSettings();
    }

    isAllSelected() {
        return this.selectedOptions.every(o => o);
    }

    isAnySelected() {
        return this.selectedOptions.some(o => o);
    }

    toggleSelectAll() {
        let newValue = !this.isAllSelected();
        this.selectedOptions.fill(newValue);
        this.$forceUpdate();
    }

    getTitle() {
        if (this.isOpened) {
            return this.single ? "<b>[ Закрыть ]</b>" : "<b>[ Применить ]</b>";
        } else {
            return `<b>${ this.name }</b>: [ ${ this.single ? this.getOptionName(this.selectedElement) : this.selectionState } ]`;
        }
    }

    getOptionName(value: any): string {
        if (this.optionKey != null) {
            return value[this.optionKey];
        } else {
            return value;
        }
    }

    getListHeight() {
        return this.listHeight + "px";
    }

    toggleDropDown() {
        if (this.isOpened) {
            if (!this.isAnySelected()) {
                this.raiseError("Выберите хотя бы одно значение!");
                return;
            }

            if (!this.single) {
                this.applyChanges();
            }
        }

        this.isOpened = !this.isOpened;
    }

    radioChanged() {
        this.$nextTick(this.applyChanges);
    }

    applyChanges() {
        if (!this.single) {
            this.selectionState = this.isAllSelected() ? SelectionState.ALL : SelectionState.SOME;
        }
        this.$emit("changed", this.single ? this.selectedElement : this.options.filter((o, i) => this.selectedOptions[i]));
    }

    raiseError(text:string) {
        this.$emit("error", text);
    }
}
